import { ErrorMessage } from '@wyz/ui';
import { Trans } from '~/common/context';
import {
  QuoteColumnarDisplay,
  QuoteLinesDisplay,
  QuoteStandardDisplay,
} from '~/purchase/components';
import { IQuoteSetting, IQuoteTyreOffer } from '~/purchase/types';

import { memo } from 'react';
import { IQuoteUiState, IUserCustomer } from '~/common/types';
import { IProductListState, ISearchTypeArgs } from '~/purchase/types';
import { IBaseTyreOffer } from '~/purchase/types';
import { QUOTE_DISPLAY_TYPE, QUOTE_VIEW_MODE } from '~/common/schemas';

type Props = {
  offers: IQuoteTyreOffer[];
  quoteSetting: IQuoteSetting;
  customer: IUserCustomer;
  uiState: IQuoteUiState;
  searchType: ISearchTypeArgs['searchType'];
  searchQuery: IProductListState['searchQuery'];
  onUpdateQuery: (tyreOffer: IBaseTyreOffer) => IBaseTyreOffer | undefined;
};
const Offers = ({
  offers,
  customer,
  quoteSetting,
  uiState,
  searchType,
  searchQuery,
  onUpdateQuery,
}: Props) => {
  const isPointOfSaleView = uiState.viewMode === QUOTE_VIEW_MODE.POINT_OF_SALE;
  return (
    <>
      {offers.length === 0 ? (
        <ErrorMessage
          title={<Trans i18nKey='app.purchase.search_page.no_results' />}
        />
      ) : (
        <>
          {(uiState.display === QUOTE_DISPLAY_TYPE.STANDARD ||
            uiState.display === QUOTE_DISPLAY_TYPE.UNSET) && (
            <QuoteStandardDisplay
              items={offers}
              customer={customer}
              quoteSetting={quoteSetting}
              requestedQuantity={searchQuery?.quantity ?? 2}
              pointOfSaleView={isPointOfSaleView}
              searchType={searchType}
              searchQuery={searchQuery}
              onUpdateQuery={onUpdateQuery}
            />
          )}
          {uiState.display === QUOTE_DISPLAY_TYPE.COLUMNAR && (
            <QuoteColumnarDisplay
              items={offers}
              customer={customer}
              quoteSetting={quoteSetting}
              requestedQuantity={searchQuery?.quantity ?? 2}
              pointOfSaleView={isPointOfSaleView}
              searchType={searchType}
              searchQuery={searchQuery}
              onUpdateQuery={onUpdateQuery}
            />
          )}
          {uiState.display === QUOTE_DISPLAY_TYPE.LINES && (
            <QuoteLinesDisplay
              items={offers}
              customer={customer}
              quoteSetting={quoteSetting}
              requestedQuantity={searchQuery?.quantity ?? 2}
              pointOfSaleView={isPointOfSaleView}
              searchType={searchType}
              searchQuery={searchQuery}
              onUpdateQuery={onUpdateQuery}
            />
          )}
        </>
      )}
    </>
  );
};

export default memo(Offers);
